<div class="search-bar">
  <input type="text" placeholder="Search tickers..." [(ngModel)]="searchQuery" (input)="onInputChange()">
  <mat-progress-bar mode="indeterminate" [style.display]="searching ? 'block' : 'none'"></mat-progress-bar>
</div>
